class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.desktopHoverQuery = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
    this.hoverCloseTimer = null;

    this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
    this.bindNestedHoverMenus();
  }

  onMouseEnter() {
    if (!this.desktopHoverQuery.matches) return;

    window.clearTimeout(this.hoverCloseTimer);
    this.closeOtherHeaderMenus();
    this.openDetails(this.mainDetailsToggle);
  }

  onMouseLeave() {
    if (!this.desktopHoverQuery.matches) return;

    window.clearTimeout(this.hoverCloseTimer);
    this.hoverCloseTimer = window.setTimeout(() => {
      if (this.contains(document.activeElement)) return;
      this.close();
    }, 120);
  }

  openDetails(detailsElement) {
    if (!detailsElement) return;

    detailsElement.setAttribute('open', '');
    detailsElement.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'true');
  }

  closeDetails(detailsElement) {
    if (!detailsElement) return;

    detailsElement.removeAttribute('open');
    detailsElement.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'false');
  }

  closeOtherHeaderMenus() {
    document.querySelectorAll('header-menu').forEach((menu) => {
      if (menu !== this && menu.mainDetailsToggle?.open) menu.close();
    });
  }

  bindNestedHoverMenus() {
    this.querySelectorAll('details details').forEach((detailsElement) => {
      let closeTimer;

      detailsElement.addEventListener('mouseenter', () => {
        if (!this.desktopHoverQuery.matches) return;

        window.clearTimeout(closeTimer);
        Array.from(detailsElement.parentElement?.parentElement?.children || []).forEach((item) => {
          const siblingDetails = item.querySelector(':scope > details');
          if (siblingDetails && siblingDetails !== detailsElement) this.closeDetails(siblingDetails);
        });
        this.openDetails(detailsElement);
      });

      detailsElement.addEventListener('mouseleave', () => {
        if (!this.desktopHoverQuery.matches) return;

        window.clearTimeout(closeTimer);
        closeTimer = window.setTimeout(() => {
          if (detailsElement.contains(document.activeElement)) return;
          this.closeDetails(detailsElement);
        }, 120);
      });
    });
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
